export default __webpack_public_path__ + "static/media/p22.3b25559d.jpg";